import { IHandler, IMetaInfo } from '../../interfaces';

export abstract class PageTitleHandler implements IHandler<IMetaInfo> {
	protected nextHandler: IHandler<IMetaInfo>;

	public setNext(handler: IHandler<IMetaInfo>): IHandler<IMetaInfo> {
		this.nextHandler = handler;
		return this.nextHandler;
	}

	construct(): IMetaInfo {
		return this.canHandle() ? this.handle() : this.next();
	}

	protected next(): IMetaInfo {
		return this.nextHandler.construct();
	}

	protected abstract canHandle(): boolean;

	protected abstract handle(): IMetaInfo;
}
